import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { Avatar } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  userAvatar: {
    width: (large) => (large ? 180 : "40px"),
    height: (large) => (large ? 180 : "40px"),
    fontSize: (large) => (large ? "3.6rem" : undefined),
    color: theme.palette.common.white,
    backgroundColor: theme.palette.secondary.main,
    [theme.breakpoints.down("sm")]: {
      margin: (large) => (large ? "auto" : undefined),
    },
  },
}));

const UserLetterAvatar = ({ firstName, lastName, avatarImage, large }) => {
  const classes = useStyles(large);

  const getNameLetters = (fName, lName) =>
    `${fName?.[0]?.toUpperCase() || ""}${lName?.[0]?.toUpperCase() || ""}`;

  return avatarImage ? (
    <Avatar className={classes.userAvatar} src={avatarImage} />
  ) : (
    <Avatar className={classes.userAvatar}>
      {getNameLetters(firstName, lastName)}
    </Avatar>
  );
};

UserLetterAvatar.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  avatarImage: PropTypes.string,
  large: PropTypes.bool,
};

UserLetterAvatar.defaultProps = {
  avatarImage: null,
  large: false,
};

export default UserLetterAvatar;
